<div class="expense-rules-list">
  <div class="rules-header">
    <div style="width: 200px;">
      <label for="currency">Default Expense Currency</label>
      <app-dropdown-input #currencySelect id="currency" [options]="currencies"
        placeholder="Select currency"></app-dropdown-input>
    </div>

    <app-button text="+ Add Rule" variant="info" (clicked)="showCreateExpenseRuleModal()" />
  </div>
  <app-trial-policy-rules-list [expenseRules]="expenseRules" (updateRule)="openUpdateRuleModal($event)">
  </app-trial-policy-rules-list>

  <div class="rules-footer">
    <app-button text="Cancel" variant="secondary" [href]="'/trial/' + trialId" fragment="policies" />

    <app-button text="Save" [isBusy]="saveProcessing" [disabled]="saveProcessing" (clicked)="saveDefaultCurrency()" />
  </div>
</div>

<app-create-expense-rule-modal [policyId]="policyId" (ruleAdded)="getExpenseRules()" #createExpenseRuleModal>
</app-create-expense-rule-modal>

<app-update-expense-rule-modal (ruleUpdated)="getExpenseRules()" #updateExpenseRuleModal>
</app-update-expense-rule-modal>
